import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var CloseSmallLinear = function CloseSmallLinear(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.414 8l2.293-2.293a.999.999 0 10-1.414-1.414L8 6.586 5.707 4.293a.999.999 0 10-1.414 1.414L6.586 8l-2.293 2.293a.999.999 0 101.414 1.414L8 9.414l2.293 2.293a.997.997 0 001.414 0 .999.999 0 000-1.414L9.414 8z",
    fill: "currentColor"
  }));
};
export default CloseSmallLinear;